export default "__VITE_ASSET__DQIiLcsO__"